<template>
<div class="chapter">
<div class="inner_page">
<p class="titlepage" id="pageiii">YOUR TOWNS &amp; CITIES IN THE GREAT WAR</p>
<p class="border">
</p><h1 class="titlepage1">THE CHANNEL ISLANDS IN THE GREAT WAR</h1>
<p class="titlepage2">STEPHEN WYNN</p>
<p class="logo"><img alt="image" src="images/Title.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?0a260286